export const FULFILLMENT_PROVIDERS_RESET_STATE = 'FULFILLMENT_PROVIDERS_RESET_STATE';
export const FULFILLMENT_PROVIDERS_CURRENT_ITEM = 'FULFILLMENT_PROVIDERS_CURRENT_ITEM';

export const FULFILLMENT_PROVIDERS_REQUEST_LOADING = 'FULFILLMENT_PROVIDERS_REQUEST_LOADING';
export const FULFILLMENT_PROVIDERS_REQUEST_SUCCESS = 'FULFILLMENT_PROVIDERS_REQUEST_SUCCESS';
export const FULFILLMENT_PROVIDERS_REQUEST_FAILED = 'FULFILLMENT_PROVIDERS_REQUEST_FAILED';

export const FULFILLMENT_PROVIDERS_CURRENT_ACTION = 'FULFILLMENT_PROVIDERS_CURRENT_ACTION';
export const FULFILLMENT_PROVIDERS_RESET_ACTION = 'FULFILLMENT_PROVIDERS_RESET_ACTION';